module.exports = "../../app/cells/pages/guides/v2_guides_card_cell.rb";